<template>
  <div class="flow-create-wrap">

    <el-button class="back-btn" @click="$router.push('/Flow/FlowMaster')">返回</el-button>

    <div class="flow-create-step-wrap">
      <el-steps :active="stepIndex" align-center class="flow-create-step">
        <el-step title="基础信息" @click.native="changeStep(0)"></el-step>
        <el-step title="数据模型" @click.native="changeStep(1)"></el-step>
        <el-step title="流程图设计" @click.native="changeStep(2)"></el-step>
        <el-step title="流程表单设计" @click.native="changeStep(3)"></el-step>
<!--        <el-step title="打印单设计" @click.native="changeStep(5)"></el-step>-->
        <el-step title="发布" @click.native="changeStep(4)"></el-step>
      </el-steps>
    </div>

    <div class="flow-create-content-wrap">
      <transition name="slide-fade" mode="out-in">
        <KeepAlive>
          <component v-model="flowData" :is="activeComponent" ref="child" />
        </KeepAlive>
      </transition>
    </div>

  </div>
</template>

<script>

import Http from "./common/Http";

export default {
  name:"flow-create",
  components: {
    'flow-create-basic'   : () => import('./components/FlowCreateBasic.vue'),
    'flow-create-model'   : () => import('./components/FlowCreateModel.vue'),
    'flow-create-form'    : () => import('./components/FlowCreateForm.vue'),
    'flow-create-chart'   : () => import('./components/FlowCreateChart.vue'),
    'flow-create-release' : () => import('./components/FlowCreateRelease.vue'),
    // 'flow-create-print' : () => import('./components/FlowCreatePrint.vue'),
  },
  data () {
    return {
      stepIndex: 0,
      componentList: {
        0: 'flow-create-basic',
        1: 'flow-create-model',
        2: 'flow-create-chart',
        3: 'flow-create-form',
        4: 'flow-create-release',
        5: 'flow-create-release',
        // 5: 'flow-create-print',
      },
      activeComponent: 'flow-create-basic',

      flowData: {

      },

      formStatus: false
    }
  },
  provide(){
    return{
      getFlowData:this.getFlowData
    }
  },
  created() {

  },
  activated() {

    let query = this.$route.query
    if(query.id > 0) {
      this.getFlowInfo(query.id)
    } else {

      this.flowData = {
        master: {
          id: 0,
        },
        model: {
          id: 0
        },
        sheet: {
          id: 0
        },
        form: {
          id: 0
        }
      }
    }

    this.stepIndex = 0
    this.activeComponent = 'flow-create-basic'
  },
  methods: {

    // 步骤变更
    changeStep(index) {

      let successFunc = () => {
        this.stepIndex = index
        this.activeComponent = this.componentList[this.stepIndex]
      }

      if(index > 0 && this.flowData.master.id == 0) {
        this.$message.warning('请先保存流程基础信息')
        return false
      }

      if(index > 1) {
        console.info(this.flowData)
        // 判断是否选中表单设置stepIndex等于2的时候就是选中表单设计
        // if (this.stepIndex === 2) {
        //   this.formStatus = true
        // } else {
        //   this.formStatus = false
        // }

        if(this.stepIndex == 3) {
          this.$refs.child.saveFormJson()
        }

        if(this.stepIndex == 1) {
          this.$refs.child.validate(res => {
            successFunc()
          })
        } else {
          let model = this.flowData.master.cache ? this.flowData.master.cache.model : this.flowData.model
          if(!model.model_name || model.model_name == '' || model.model_table == '') {
            this.$message.warning('请先填写数据模型信息')
            index = 1
          }
          successFunc()
        }

        return

      }

      successFunc()
    },

    // 下一步
    nextStep() {
      if(this.stepIndex < 4) {
        this.changeStep(this.stepIndex + 1)
      }
    },

    // 获取流程信息
    getFlowInfo(id) {
      Http.get("flow/FlowMaster/getFlowInfo", {id: id}, res => {
        if(res.code == 1) {
          this.flowData = Object.assign({
            master: {
              id: 0,
            },
            model: {
              id: 0
            },
            sheet: {
              id: 0
            },
            form: {
              id: 0
            }
          }, res.data)
        } else {
          this.$message.warning(res.msg ? res.msg : '读取数据错误')
        }
      })
    },
    getFlowData(){
      return this.flowData
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.el-step {
  cursor: pointer;
}

.flow-create-wrap {
  position: relative;

  .back-btn {
    position: absolute;
  }
}

.slide-fade-enter-active {
  transition: all .15s ease-in;
}
.slide-fade-leave-active {
  transition: all .15s ease-out;
}
.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/FlowCreate.vue